function sendBeacon(endpoint, data) {
    try {
        const payload = JSON.stringify(data);
        const blob = new Blob([payload], { type: 'application/json' });
        
        const success = navigator.sendBeacon(endpoint, blob);
        
        if (!success) {
            console.warn('Beacon failed to queue, falling back to fetch');
            return fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: payload,
                keepalive: true
            }).catch(err => console.error('Fetch fallback failed:', err));
        }
        
        return Promise.resolve(success);
    } catch (error) {
        console.error('Error sending beacon:', error);
        return Promise.reject(error);
    }
}

function trackViewedPage(urls, dh, uid) {

    const endpoint = 'https://apiapi.ombligo.com/ms/v/page/'

    const urlArray = Array.isArray(urls) ? urls : [urls];

    const user = uid || dh || 'unknown';
    
    const data = {
        pages: urlArray,
        user: user
    };
    
    return sendBeacon(endpoint, data);
}

function trackViewedProduct(products, dh, uid) {
    const endpoint = 'https://apiapi.ombligo.com/ms/v/product/'
    
    const productArray = Array.isArray(products) ? products : [products];
    
    const user = uid || dh || 'unknown';

    const data = {
        product: productArray,
        user: user
    };
    
    return sendBeacon(endpoint, data);
}

function manageSessionStore(type = "page", currPage = "", currProduct = "", currProductType = "", cto_hash = "") {
    let sessionStore = [];
    if (type == "page") {
        sessionStore = sessionStorage.getItem('sessionStore');
        if (!sessionStore) {
            sessionStore = [];
        } else {
            sessionStore = JSON.parse(sessionStore); 
        }
        const exists = sessionStore.some(item => item.url === currPage);
        if (!exists) {
            sessionStore.push({ url: currPage, timestamp: new Date().toISOString() });
            sessionStorage.setItem('sessionStore', JSON.stringify(sessionStore));
        }
    }  
    if (type == "product") {
        sessionStore = sessionStorage.getItem('sessionStoreProduct');
        if (!sessionStore) {
            sessionStore = [];
        } else {
            sessionStore = JSON.parse(sessionStore);
            
        }
        const exists = sessionStore.some(item => item.product_sku === currProduct && item.product_type === currProductType);
        if (!exists) {
            sessionStore.push({ product_sku: currProduct, product_type: currProductType });
            sessionStorage.setItem('sessionStoreProduct', JSON.stringify(sessionStore));
        }
    }
    if (type == "server") {
        sessionStore = sessionStorage.getItem('sessionStoreProduct');
        if (!sessionStore) {
            sessionStore = [];
        } else {
            sessionStore = JSON.parse(sessionStore);
        }

        const index = sessionStore.findIndex(item => item.product_sku === currProduct && item.product_type === currProductType);
        if (index !== -1) {
            sessionStore[index].cto_hash = cto_hash;
            sessionStorage.setItem('sessionStoreProduct', JSON.stringify(sessionStore));
        } else {
            sessionStore.push({ product_sku: currProduct, product_type: currProductType, cto_hash: cto_hash });
            sessionStorage.setItem('sessionStoreProduct', JSON.stringify(sessionStore));
        
        }
    }

    if (sessionStore.length == 2){
        if (type == "product") sessionStorage.removeItem('sessionStoreProduct');
        if (type == "page") sessionStorage.removeItem('sessionStore');
        return sessionStore;
    }
    return null;
}